import React from 'react';
import { heroImages } from '../mock';
import { PillPrimary } from '../components/PillButton';

const EcommerceEtico = () => (
  <div className="bg-[#2b2b2b]">
    <section className="pt-32 pb-16 md:pt-40 md:pb-24 bg-[#141414] relative overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-center opacity-25" style={{ backgroundImage: `url(${heroImages.sustainable1})` }} />
      <div className="relative max-w-[1200px] mx-auto px-6 lg:px-10 text-center">
        <div className="inline-block px-5 py-2.5 rounded-full border border-[#e9dfc0]/40 text-[#e9dfc0] text-[13px] mb-6">Chi siamo</div>
        <h1 className="font-serif text-white text-5xl md:text-7xl leading-[1.05] mb-6">Ecommerce Etico</h1>
        <p className="text-[#e9dfc0]/85 text-[17px] max-w-3xl mx-auto">Crediamo che vendere online debba avere un impatto positivo su persone, aziende e ambiente.</p>
      </div>
    </section>

    <section className="py-24">
      <div className="max-w-[1000px] mx-auto px-6 lg:px-10 space-y-8 text-[#e9dfc0]/90 text-[17px] leading-relaxed">
        <p>Il commercio elettronico ha rivoluzionato il modo in cui compriamo e vendiamo, ma può anche essere un potente strumento di cambiamento. Per noi “etico” significa scegliere fornitori consapevoli, misurare la sostenibilità delle scelte logistiche e comunicare con trasparenza al cliente finale.</p>
        <p>Selezioniamo brand impact-driven con cui costruire percorsi dedicati: packaging riciclabile, filiera corta, calcolo carbon footprint delle spedizioni e comunicazione onesta. Nessun greenwashing, solo scelte concrete e misurabili.</p>
        <p>Ogni progetto etico prevede un audit iniziale sull'intera filiera, la definizione di KPI ambientali e sociali, e un percorso di miglioramento continuo. Perché la sostenibilità non è un claim, è un processo.</p>
      </div>
    </section>

    <section className="bg-[#3a3a3a] py-20">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <h2 className="font-serif text-white text-3xl md:text-4xl mb-6">Vuoi costruire un brand a impatto positivo?</h2>
        <PillPrimary to="/contatti">Contattaci</PillPrimary>
      </div>
    </section>
  </div>
);

export default EcommerceEtico;
